import { AdPositionEnum } from "../client/api";

export type AdSenseConfig = {
  adSlot: string;
  adFormat: "fluid" | "auto";
  adLayoutKey?: string;
  fullWidthResponsive?: boolean;
};

export enum AdSensePositionEnum {
  MATCH_RIGHT_RAIL = "MATCH_RIGHT_RAIL",
  TEAM_RIGHT_RAIL = "TEAM_RIGHT_RAIL",
  PLAYER_RIGHT_RAIL = "PLAYER_RIGHT_RAIL"
}

export const ADSENSE_CONFIG: Partial<Record<AdPositionEnum | AdSensePositionEnum, AdSenseConfig>> = {
  [AdPositionEnum.HOME_MATCH]: {
    adSlot: "9203244542",
    adFormat: "fluid",
    adLayoutKey: "-fb+5w+4e-db+86"
  },
  [AdPositionEnum.HOME_MATCH_DOUBLE]: {
    adSlot: "9203244542",
    adFormat: "fluid",
    adLayoutKey: "-fb+5w+4e-db+86"
  },
  [AdPositionEnum.LEAGUE_MATCH_MATCH]: {
    adSlot: "9010661097",
    adFormat: "fluid",
    adLayoutKey: "-6t+ed+2i-1n-4w"
  },
  [AdPositionEnum.MATCH_LINEUP]: {
    adSlot: "8627517717",
    adFormat: "auto",
    fullWidthResponsive: true
  },
  [AdPositionEnum.MATCH_SCREEN_BANNER]: {
    adSlot: "4653625447",
    adFormat: "auto",
    fullWidthResponsive: true
  },
  [AdPositionEnum.HOME_SCREEN_BANNER]: {
    adSlot: "2495200113",
    adFormat: "fluid",
    adLayoutKey: "-fb+5w+4e-db+86"
  },
  [AdPositionEnum.LEAGUE_SCREEN_BANNER]: {
    adSlot: "4174279144",
    adFormat: "auto",
    fullWidthResponsive: true
  },
  [AdPositionEnum.TEAM_SCREEN_BANNER]: {
    adSlot: "9770220758",
    adFormat: "auto",
    fullWidthResponsive: true
  },
  [AdPositionEnum.NEWS_ADS]: {
    adSlot: "3368873053",
    adFormat: "auto",
    fullWidthResponsive: true
  },
  [AdSensePositionEnum.MATCH_RIGHT_RAIL]: {
    adSlot: "8289386614",
    adFormat: "auto",
    fullWidthResponsive: true
  },
  [AdSensePositionEnum.TEAM_RIGHT_RAIL]: {
    adSlot: "8457548205",
    adFormat: "auto",
    fullWidthResponsive: true
  },
  [AdSensePositionEnum.PLAYER_RIGHT_RAIL]: {
    adSlot: "4142080434",
    adFormat: "auto",
    fullWidthResponsive: true
  }
};

export const ADSENSE_CLIENT_ID = "ca-pub-9466306924240475";

